import { useParams } from "react-router"
// import { GraphiQL } from "graphiql"

import envs from "../../config/envs"
import { createGraphiQLFetcher } from "@graphiql/toolkit"
import { useEffect, useMemo, useState } from "react"
import { useAuthHeaders } from "../auth/AuthState"
import { useExplorerPlugin } from '@graphiql/plugin-explorer';

import '@graphiql/plugin-explorer/dist/style.css';
import RTAPIIcon from "../explorer/components/RealtimeApiIcon"
import CopyToClipboard from "react-copy-to-clipboard"
import { BiCopy } from "react-icons/bi"

import eth from './assets/ethereum.svg'
import sui from './assets/Sui.svg'

import { toast } from "react-toastify"
import { AuthApi } from "../../api/client"
import { GraphiQL } from "../dataset/GraphqlV4"
import { searchQueryPrompts } from "./apis"
import { ModelQueryPrompt } from "../../api/__gen__/data-contracts"

const refreshAccessToken = async () => {
  const client = AuthApi();
  const resp = await client.postAuth();
  return resp.data.accessToken
}

const RealtimeAPIGQL = () => {
  const headers = useAuthHeaders();

  const [query, setQuery] = useState('# Welcome to GraphiQL\n');
  const plugin = useExplorerPlugin({
    title: 'Query Explorer',
    query,
    onEdit: setQuery,
    showAttribution: false,
  });

  const { name } = useParams()

  const [accessToken, setAccessToken] = useState('');

  const [queryPrompts, setQueryPrompts] = useState<ModelQueryPrompt[]>([])


  const fetchAndSetQueryPrompts = async (keywords?: string) => {
    const data = await searchQueryPrompts(
      'ethereum',
      keywords ? keywords.split(',').map(e => e.trim()) : [],
      'graphql'
    )
    setQueryPrompts(data)
  }

  useEffect(() => {
    fetchAndSetQueryPrompts()
  }, [])



  useEffect(() => {
    const interval = setInterval(async () => {
      const token = await refreshAccessToken();
      setAccessToken(token || '');
    }, 60000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  const fetcher = useMemo(() => {
    return createGraphiQLFetcher({
      // 
      // https://qugate-dev-ztbl.api.zettablock.dev/pubgate/v1/ethereum/graphql
      // url: `${envs.ZettaBackendApiPrivate}/${name}/graphql`,
      url: `${envs.ZettaBackendApiPrivate}/${name}/graphql`,
      // @ts-ignore
      headers: accessToken ? {
        Authorization: `Bearer ${accessToken}`
      } : headers,
    });
  }, [name, headers, accessToken]);

  return <div >
    <div className='flex'>
      <div className='flex-auto flex items-center space-x-3 overflow-hidden'>
        <div>
          <div className='flex items-center bg-[#261be6] rounded pr-3 pl-1 py-1'><RTAPIIcon fill={"#fff"} height={21} /><span className='text-sm font-semibold text-[#fff]'>REAL-TIME</span> </div>

        </div>
        <div className='flex items-center space-x-2 overflow-hidden pr-2'>
          <img src={name !== 'sui' ? eth : sui} width={21} />
          <span
            title={'values.displayName'}
            className='flex-auto font-bold text-lg overflow-hidden text-ellipsis whitespace-nowrap'
          >
            {name !== 'sui' ? 'Ethereum Mainnet' : 'Sui'}
          </span>
        </div>
      </div>
    </div>
    <div className='flex min-w-[40rem] my-6'>
      <div className='rounded-l-lg inline-block border-r bg-primary-content'>
        <span
          className='inline-block text-xs opacity-30 font-semibold px-1 pb-3 pt-1 text-center justify-center'
          style={{ writingMode: 'vertical-lr', transform: 'rotate(180deg)' }}
        >
          INFO
        </span>
      </div>
      <div className='rounded-r-lg bg-primary-content text-sm'>
        <div className='flex flex-col gap-1 py-2 px-3'>
          <div className='text-xs font-bold opacity-30'>GraphQL URL</div>
          <CopyToClipboard
            text={`${envs.ZettaBackendApiPrivate}/${name}/graphql`}
          >
            <div
              className='flex gap-2 items-center cursor-pointer'
              onClick={() => {
                toast.success('Copied to clipboard', {
                  autoClose: 2000,
                })
              }}
            >
              <div className='flex-1'>{`${envs.ZettaBackendApiPrivate}/${name}/graphql`}</div>
              <BiCopy size='.8rem' className='opacity-40' />
            </div>
          </CopyToClipboard>

          {/* {openInfoModal && (
              <ApiInfoModal open={openInfoModal} setOpen={setOpenInfoModal} />
            )} */}
        </div>
      </div>
    </div>

    <div className="h-[calc(100vh-200px)]">
      <GraphiQL
        apiId=""
        query={query}
        fetcher={fetcher}
        plugins={[plugin]}
        defaultQuery="# Welcome to Realtime API"
        queryPrompts={queryPrompts}
        onSearchQueryPrompts={fetchAndSetQueryPrompts}
        onPromptSelected={(prompt: string) => { setQuery(prompt) }}
      />
    </div>

  </div>
}

export default RealtimeAPIGQL